import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, IconButton, Button, Typography, Grid, Grid2, FormControlLabel, Checkbox, Avatar } from '@mui/material';
import { Google as GoogleIcon, Facebook as FacebookIcon, Apple as AppleIcon, Close as CloseIcon, VisibilityOff, Visibility } from '@mui/icons-material';
import './LoginModal.css'; // Archivo CSS para los estilos personalizados
import { useApi } from '../../services/ApiServices.tsx';
import { LoginResponse } from '../../interfaces/Login.interface.ts';
import { useAuth } from '../Auth/AuthContext.tsx';
import Loader from '../Loader.jsx';
import ReCAPTCHA from "react-google-recaptcha";

const logoMenuBlanco = require('../../assets/img/logo-menu-white.png');
const iconoSeparador = require('../../assets/img/icon-separator.png');
const defaultAvatar = require('../../assets/img/chilin-profile.png');
const googleLogo = require('../../assets/img/googleLogo.png');

interface LoginComponentProps {
    onLoginSuccess: (data: any) => void;
    onSwitchToRegister: () => void;
    onClose: () => void;
    rechaptchaSiteKey: string;
}

const LoginComponent: React.FC<LoginComponentProps> = ({ onLoginSuccess, onSwitchToRegister, onClose, rechaptchaSiteKey }) => {
    const { ApiRequest } = useApi();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [captchaValue, setCaptchaValue] = useState<string | null>(null);
    const recaptchaRef = useRef<any>(null);
    const { login } = useAuth();
    const [error, setError] = useState("");
    const [errorMessage, setErrorMessage] = useState('');

    const handleCaptchaChange = (value: string | null) => {
        setCaptchaValue(value);
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    const handleGoogleLogin = async () => {
        try {

            //const baseURLUsers = process.env.REACT_APP_API_URL_USERS;
            const baseURLUsers = window.REACT_APP_API_URL_USERS || "https://hoytoca2025-user-service.prd.cloudherdez.com";

            // Redirige la ventana principal a la URL de inicio de sesión con Google
            window.location.href = `${baseURLUsers}/api/auth/google/login`;
        } catch (error) {
            console.error("Error al redirigir:", error);
            setError("No se pudo redirigir al inicio de sesión con Google.");
        }
    };

    const handleLogin = async () => {
        if (!email || !password) {
            alert('Por favor, completa todos los campos.');
            return;
        }

        if (!captchaValue) {
            alert('Por favor, completa el reCAPTCHA para continuar.');
            return;
        }

        setIsLoading(true);

        try {
            setIsLoading(true);
            const body = JSON.stringify({ username: email, password: password, CaptchaToken: captchaValue });
            const response = await ApiRequest('api/Auth/Login', 'POST', body, true);
            console.log("login", response);

            const data: LoginResponse = response;

            if (data.token && data.user && data.user !== null && data.token !== "") {
                login(data.user, data.token);
                onClose();
            } else {
                alert(data.error || 'Error al iniciar sesión');
                recaptchaRef.current?.reset();
                setCaptchaValue(null);
            }
        } catch (error) {
            alert('Hubo un error al iniciar sesión. Inténtalo nuevamente.');
            console.error(error);
            recaptchaRef.current?.reset();
            setCaptchaValue(null);
        } finally {
            setIsLoading(false);
        }
    };

    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setEmail(value);
    
        if (!validateEmail(value)) {
          setErrorMessage('Por favor, ingresa un correo electrónico válido.');
        } else {
          setErrorMessage('');
        }
      };

    return (
        <DialogContent className="login-modal-paper">
            <Grid2 className="login-modal-content">
                <Grid2 className="main-text">
                    <span className="highlight-black">Registrate</span>&nbsp;
                    <span className="highlight-gray">o inicia sesión</span>
                </Grid2>

                <Grid container direction="column" spacing={2} className="modal-container-title">
                    <Typography variant="h6" className="login-title">
                        Correo electrónico
                    </Typography>
                    <Grid2 className="login-search-box">
                        <input
                            className="login-search-input"
                            type="email"
                            placeholder="Ejemplo: ejemplo@correo.com"
                            value={email}
                            onChange={handleInputChange}
                        />
                    </Grid2>
                    <Grid2>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                    </Grid2>

                    <Typography variant="h6" className="login-title">
                        Contraseña
                    </Typography>
                    <Grid2>
                        <Grid2 className="login-search-box">
                            <Grid2 className="login-search-icon">
                                <IconButton onClick={handleTogglePasswordVisibility} size="small">
                                    {!showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </Grid2>
                            <input
                                className="login-search-input"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Ingresa tu contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Grid2>
                        <Grid2 container size={12} justifyContent="flex-end" alignItems="center">
                            <Button className='login-button-enviar' variant="contained"
                                color="primary"
                                onClick={handleLogin}
                                style={{ textTransform: 'none' }} >
                                Enviar
                            </Button>
                        </Grid2>
                        <Grid2 container size={12} alignItems="center">
                            <Grid2>
                                <ReCAPTCHA
                                    sitekey={rechaptchaSiteKey}
                                    onChange={handleCaptchaChange}
                                    ref={recaptchaRef}
                                />
                            </Grid2>
                        </Grid2>
                        <Grid2 container size={12} justifyContent="center" alignItems="center" style={{ marginTop: '10px' }}>
                            <Grid2 container alignItems="center" justifyContent="center" spacing={0}>
                                <div className="separator">
                                    <div className="line"></div>
                                    <img src={iconoSeparador} alt="separator" className="separator-img" />
                                    <div className="line"></div>
                                </div>
                            </Grid2>
                        </Grid2>
                    </Grid2>



                    <Grid2 container size={12} justifyContent="center" alignItems="center" style={{ marginTop: '20px', width: '100%', flexDirection: 'column' }}>
                        <Grid item className="third-party-login">
                            <Button
                                variant="text"
                                startIcon={(
                                    <img
                                        src={googleLogo}
                                        alt="Google"
                                        style={{ width: '24px', height: '24px' }}
                                    />
                                )} // Color de Google logo
                                fullWidth
                                style={{
                                    textDecoration: 'underline',
                                    textDecorationColor: '#666666',
                                    color: '#666666', // Color del texto
                                    textTransform: 'none',
                                }}
                                onClick={handleGoogleLogin}
                            >
                                Continuar con Google
                            </Button>
                        </Grid>
                        {/* <Grid item className="third-party-login">
                    <Button
                      variant="text"
                      startIcon={<FacebookIcon style={{ color: '#1877F2' }} />} // Color de Facebook logo
                      fullWidth
                      style={{
                        textDecoration: 'underline',
                        textDecorationColor: '#666666',
                        color: '#666666', // Color del texto
                      }}
                      onClick={handleFacebookLogin}
                    >
                      Iniciar sesión con Facebook
                    </Button>
                  </Grid> */}
                        {/* <Grid item className="third-party-login">
                            <Button
                                variant="text"
                                startIcon={<AppleIcon style={{ color: '#000000' }} />} // Color de Apple logo
                                fullWidth
                                style={{
                                    textDecoration: 'underline',
                                    textDecorationColor: '#666666',
                                    color: '#666666', // Color del texto
                                }}
                            >
                                Iniciar sesión con Apple
                            </Button>
                        </Grid> */}
                    </Grid2>


                </Grid>
            </Grid2>
        </DialogContent>
    );
};

export default LoginComponent;
